import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EntityCrudService } from '@data/entity-crud.service';
import { StudyField } from '@data/study-field/study-field.model';

@Injectable({
  providedIn: 'root',
})
export class StudyFieldService extends EntityCrudService<StudyField, StudyField> {
  constructor() {
    const http = inject(HttpClient);

    super('study-fields', http);
  }
}
